import { Trash2, X } from 'lucide-react';
import type { AcademyVideoItem } from '../types';

interface AcademyDeleteVideoDialogProps {
    isOpen: boolean;
    video: AcademyVideoItem | null;
    isDeleting: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function AcademyDeleteVideoDialog({
    isOpen,
    video,
    isDeleting,
    onConfirm,
    onCancel,
}: AcademyDeleteVideoDialogProps) {
    if (!isOpen || !video) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200"
                onClick={onCancel}
            />
            <div className="relative z-10 w-full max-w-md rounded-2xl border border-border bg-card shadow-2xl animate-in zoom-in-95 fade-in duration-200">
                <div className="flex items-center gap-3 p-5 border-b border-border/50">
                    <div className="p-2 rounded-xl bg-red-500/10">
                        <Trash2 size={18} className="text-red-400" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-base font-semibold text-foreground">Eliminar Vídeo</h3>
                        <p className="text-xs text-muted-foreground truncate mt-0.5">"{video.title}"</p>
                    </div>
                    <button
                        onClick={onCancel}
                        className="p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
                    >
                        <X size={16} />
                    </button>
                </div>
                <div className="p-5">
                    <p className="text-sm text-muted-foreground">
                        Esta acción eliminará el vídeo y todas sus valoraciones y comentarios. No se puede deshacer.
                    </p>
                </div>
                <div className="flex items-center justify-end gap-2 p-5 pt-0">
                    <button
                        onClick={onCancel}
                        disabled={isDeleting}
                        className="px-4 py-2 rounded-lg text-sm font-medium bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isDeleting}
                        className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/20 transition-colors disabled:opacity-50"
                    >
                        {isDeleting ? (
                            <>
                                <span className="w-4 h-4 border-2 border-red-400 border-t-transparent rounded-full animate-spin" />
                                Eliminando...
                            </>
                        ) : (
                            <>
                                <Trash2 size={14} />
                                Eliminar
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
